import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sortedBy } from "../../features/sort/SortSlice";

export default function SortBlogs () {
    const dispatch = useDispatch();
    const { value } = useSelector(state => state.sort);

    const [sortBy, setSortBy] = useState(value);
    const handleSortChange = (optionSelected) => {
        setSortBy(optionSelected);
        dispatch(sortedBy(optionSelected));
    }

    return (
        <div className="sidebar-content">
            <h4>Sort</h4>
            <select
                value={sortBy}
                onChange={(e) => handleSortChange(e.target.value)}
                name="sort"
                id="lws-sort"
                className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
            >
                <option value="default">Default</option>
                <option value="newest">Newest</option>
                <option value="most_liked">Most Liked</option>
            </select>
        </div>
    );
}